document.addEventListener('DOMContentLoaded', function() {
  // Handle tab switching
  document.querySelectorAll('.tab-item').forEach(tab => {
    tab.addEventListener('click', () => {
      let selectedTab = tab.dataset.tab;

      // Switch active tab
      document.querySelectorAll('.tab-item').forEach(t => t.classList.remove('active'));
      tab.classList.add('active');

      // Switch tab content
      document.querySelectorAll('.tab-content').forEach(c => {
        c.classList.toggle('active', c.dataset.tab === selectedTab);
      });

      initSliderDots(tab.closest('.pdp-video-tabs-main-container').querySelector('.tab-content.active'));
    });
  });

  // Handle video play
  document.querySelectorAll('.play-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      let videoUrl = btn.dataset.video;
      let card = btn.closest('.video-card');

      card.innerHTML = `<video controls autoplay loop muted class="fill-media fixed-height">
          <source src="${videoUrl}" type="video/mp4">
           Your browser does not support the video tag.
        </video>`;
    });
  });

  function initSliderDots(tabContent) {
    let slider = tabContent.querySelector('.slider-wrapper');
    if (!slider) return;

    let cards = slider.querySelectorAll('.video-card');
    let dotsContainer = tabContent.querySelector('.slider-dots');
    dotsContainer.innerHTML = '';

    cards.forEach((_, i) => {
      let dot = document.createElement('span');
      dot.classList.add('dot');
      if (i === 0) dot.classList.add('active');
      dot.addEventListener('click', () => {
        slider.scrollTo({
          left: cards[i].offsetLeft,
          behavior: 'smooth'
        });
      });
      dotsContainer.appendChild(dot);
    });

    slider.addEventListener('scroll', () => {
        let scrollLeft = slider.scrollLeft;
        let activeIndex = 0;

        cards.forEach((card, i) => {
            if (scrollLeft >= card.offsetLeft - slider.clientWidth / 2) {
            activeIndex = i;
            }
        });
        dotsContainer.querySelectorAll('.dot').forEach((d, i) => {
            d.classList.toggle('active', i === activeIndex);
        });
    });
  }

  // Init dots for first active tab
  initSliderDots(document.querySelector('.tab-content.active'));
}); 

